// extracted by mini-css-extract-plugin
export default {"AccountTypeFormModal":"AccountTypeFormModal_AccountTypeFormModal__fXUmB"};